import type { AnnotatedPrayerSlot, DaySchedule, PrayerStatus } from "./types";

const ISHA_CURRENT_WINDOW_MS = 90 * 60 * 1000;

/**
 * Annotates each prayer with completed / current / upcoming based on the
 * Azaan time. "Current" runs from a prayer's Azaan until the next prayer's
 * Azaan; for Isha (no next prayer today) the current window is 90 minutes.
 */
export function annotateSchedule(schedule: DaySchedule, now: Date): AnnotatedPrayerSlot[] {
  const prayers = schedule.prayers;
  const out: AnnotatedPrayerSlot[] = [];

  for (let i = 0; i < prayers.length; i++) {
    const p = prayers[i];
    if (!p) continue;
    const next = prayers[i + 1];

    let status: PrayerStatus;
    if (now < p.azaanTime) {
      status = "upcoming";
    } else if (next) {
      status = now >= next.azaanTime ? "completed" : "current";
    } else {
      status =
        now.getTime() - p.azaanTime.getTime() < ISHA_CURRENT_WINDOW_MS
          ? "current"
          : "completed";
    }
    out.push({ ...p, status });
  }

  return out;
}
